export default [
  {
    path: "/messages/:userId?",
    name: "messages",
    component: () => import(/* webpackChunkName: "message" */ "../views/message/vMessages.vue"),
    meta: { title: "Messages", auth: false, roles: null },
  },
];
